import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { TagsDropdown } from "./tags-dropdown.component";
import styles from "./change-tags-modal.module.scss";
import CrossIcon from "../../../../../icons/cross.icon";

export const ChangeTagsModal = ({ show = false, onHide }) => {
  const [selectedTags, setSelectedTags] = useState(["Referral", "Hot Lead"]);
  const [inputValue, setInputValue] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // Mock menu items - replace with actual data from API
  const [menuItems, setMenuItems] = useState([
    { id: 1, label: "Strategic Partner", type: "option" },
  ]);

  const handleRemoveTag = (tagToRemove) => {
    setSelectedTags(selectedTags.filter((tag) => tag !== tagToRemove));
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    // Always show dropdown when typing
    setShowDropdown(true);
  };

  const handleInputFocus = () => {
    // Always show dropdown on focus
    setShowDropdown(true);
  };

  const handleItemClick = (label) => {
    if (!selectedTags.includes(label)) {
      setSelectedTags([...selectedTags, label]);
    }
    setInputValue("");
    setSelectedItem(label);
    setShowDropdown(false);
  };

  const handleAddClick = () => {
    const newTag = inputValue.trim();
    if (newTag && !selectedTags.includes(newTag)) {
      setSelectedTags([...selectedTags, newTag]);
      
      // Add to menuItems if it doesn't already exist
      const tagExists = menuItems.some(item => item.label === newTag);
      if (!tagExists) {
        const newId = Math.max(...menuItems.map(item => item.id), 0) + 1;
        setMenuItems([...menuItems, { id: newId, label: newTag, type: "option" }]);
      }
      
      setInputValue("");
    }
    setShowDropdown(false);
  };


  const handleCancel = () => {
    onHide();
  };

  const handleAddToExisting = () => {
    // Handle add to existing tags action
    console.log("Add to existing tags:", selectedTags);
    onHide();
  };

  const handleReplaceTags = () => {
    // Handle replace tags action
    console.log("Replace tags:", selectedTags);
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="change-tags-modal-dialog"
      className={styles.modal}
      aria-labelledby="change-tags-modal"
    >
      <Modal.Header className={styles.headerContainer}>
        <div className={styles.headerContent}>
          <div className={styles.closeButtonWrapper}>
            <button
              className={styles.closeButton}
              onClick={onHide}
              type="button"
              aria-label="Close modal"
            >
              <CrossIcon fill="#616778" width={10} height={10} />
            </button>
          </div>

          <div className={styles.titleWrapper}>
            <div className={styles.title}>Tags</div>
          </div>
        </div>

        <div className={styles.dividerWrapper}>
          <div style={{ borderTop: "1px solid rgba(235, 237, 241, 1)", width: "100%" }} />
        </div>
      </Modal.Header>

      <Modal.Body className={styles.content}>
        <p className={styles.description}>
          Select the tags you want to add/replace to this selection
        </p>

        <div className={styles.tagsContainer}>
          <div className={styles.tagsLabel}>Tags</div>

          <TagsDropdown
            menuItems={menuItems}
            inputValue={inputValue}
            onInputChange={handleInputChange}
            onInputFocus={handleInputFocus}
            onItemClick={handleItemClick}
            onAddClick={handleAddClick}
            selectedItem={selectedItem}
            show={showDropdown}
            onToggle={setShowDropdown}
            selectedTags={selectedTags}
            onRemoveTag={handleRemoveTag}
          />
        </div>
      </Modal.Body>

      <Modal.Footer className={styles.footer}>
        <div className={styles.footerContent}>
          <button
            className={styles.cancelButton}
            onClick={handleCancel}
            type="button"
          >
            Cancel
          </button>
          <div className={styles.buttonGroup}>
            <button
              className={styles.primaryButton}
              onClick={handleAddToExisting}
              type="button"
            >
              Add to Existing Tags
            </button>
            <button
              className={styles.primaryButton}
              onClick={handleReplaceTags}
              type="button"
            >
              Replace Tags
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};